<router-outlet></router-outlet>

<app-secondary-nav-contacts [contactIn]="contact"></app-secondary-nav-contacts>
